import { useEffect, useState } from 'react';
import './Table.css';
import db from './db';

function Albums(props) {
    const albums = props.allAlbums;
    
    return (
        <>
        <h2 >Albums:</h2>
            <table style={{color:"black"}}>
                <tr className="bg-white">
                    <th>media</th>
                    <th>sender</th>
                    <th>mode</th>
                    <th>files</th>
                    <th>seen</th>
                </tr>
                 
                {albums?.map(element => {
                    
                return <tr className="bg-white" style={{color: element.seen=="true" ? "red" : element.seen=="false" ? "green": "black"}}>
                    <td>{element.media}</td>
                    <td>{element.sender}</td>
                    <td>{element.mode}</td>
                    <td>{element.files ? element.files.map(file => file+ ", " ) : element.images.map(file => file+ ", " )}</td>
                    <td >{element.seen}</td>
                        
                    </tr>} )} 
                
                </table>
        </>
    );
}

export default Albums;